import * as types from './constants'

import { ColorRecord, ColorSourceObjectType } from 'shared/models/Color'

export function pushColors(colors: (ColorRecord | ColorSourceObjectType)[]) {
  return { type: types.PUSH_COLORS, colors }
}
